<template>
  <v-container
    fill-height
    fluid
    grid-list-xl>
    <v-layout
      justify-center
      wrap
    >
      <v-flex
        md12
        lg12>
        <material-card
          color="general"
          class="card-tabs"
        >
          <v-flex
            slot="header"
          >
            <v-tabs
              v-model="tab"
              color="transparent"
              slider-color="white"
            >

              <v-tab
                v-for="item in tabSlot"
                :key="item.key"
                :disabled="hasPermission(item.permission) === false"
              >
                {{ item.tab }}
              </v-tab>
            </v-tabs>
          </v-flex>

          <v-tabs-items
            v-model="tab"
            :touchless="true">
            <v-tab-item
              key="1"
            >
              <list-visit
                visit-type="SALES"
              />
            </v-tab-item>
            <v-tab-item
              key="2"
            >
              <list-visit
                visit-type="PROJECT"
              />
            </v-tab-item>
          </v-tabs-items>
        </material-card>
      </v-flex>

    </v-layout>
  </v-container>
</template>
<script>
  import ListVisit from './visit/ListVisit'
  import { mapGetters } from 'vuex'

  export default {
    name: 'Visit',
    components: { ListVisit },
    data: () => ({
      tab: null,
      tabSlot: [
        { key: 1, tab: 'SALES VISIT / ACTIVITY', content: 'Tab 1 Content', permission: 'MA_SHODAN' },
        { key: 2, tab: 'PROJECT VISIT', content: 'Tab 2 Content', permission: 'MA_PROJECT' }
      ]

    }),

    computed: {
      ...mapGetters(['hasPermission']) // without modules
    },
    watch: {},
    created () {
      this.tab = parseInt(this.$route.query.tab)
    },
    methods: {}
  }
</script>
<style>

</style>
